<div class="multicharts-section">
  <div class="multicharts-content">
    <div class="charts-row" [ngStyle]="{'grid-template-columns': 'repeat(' + gridColumns + ', 1fr)'}">
      <div *ngFor="let c of data.charts; let i = index" class="chart-panel"
           [class.chart-panel--maximized]="maximizedIndex === i"
           [class.chart-panel--hidden]="maximizedIndex !== null && maximizedIndex !== i">
        <div class="chart-label">
          <span class="chart-label__name" *ngIf="c.label" [title]="c.label">{{ (c.label | slice:0:15) + (c.label.length > 15 ? '…' : '') }}</span>
          <span class="chart-label__sym">
            <span *ngIf="c.label">· </span>
            <ng-container *ngIf="c.availableAssets && c.availableAssets.length > 1; else symOnly">
              <select class="asset-select-native" [class.dark]="isDark" [value]="c.symbol" (change)="onAssetSelected(i, $any($event.target).value)">
                <option *ngFor="let a of c.availableAssets" [value]="a.iso" [selected]="(a.iso || '').toUpperCase() === (c.symbol || '').toUpperCase()">{{ a.nombre || a.iso }}</option>
              </select>
            </ng-container>
            <ng-template #symOnly>{{ c.symbol }}</ng-template>
          </span>

          <span class="period-badge" *ngIf="chartMeta[i]?.periodo != null">
            {{ getPeriodoLabel(chartMeta[i]?.periodo) }}
          </span>
          <mat-icon
            *ngIf="chartMeta[i]?.bajista !== undefined"
            class="trend-icon"
            [class.trend-down]="chartMeta[i]?.bajista"
            [class.trend-up]="!chartMeta[i]?.bajista"
            [matTooltip]="chartMeta[i]?.bajista ? 'Bajista' : 'Alcista'"
            style="font-size: var(--font-size-md); width:16px;height:16px;line-height:16px;">
            {{ chartMeta[i]?.bajista ? 'trending_down' : 'trending_up' }}
          </mat-icon>

          <span *ngIf="c.metaapi && livePrices[c.symbol.toUpperCase()]" class="live-badge"
                [matTooltip]="'Ask: ' + (livePrices[c.symbol.toUpperCase()].ask | number:'1.5-5')">
            <span class="live-dot"></span>
            {{ livePrices[c.symbol.toUpperCase()].bid | number:'1.5-5' }}
          </span>
          <a *ngIf="c.idModelo"
             [href]="'/models?id=' + c.idModelo + '&fecharegistrosuscripcion=' + c.fechaRegistroSuscripcion + '&idcarteraoptima=' + c.idCarteraOptima"
             target="_blank" mat-icon-button matTooltip="Ver en Modelo"
             style="width:24px;height:24px;line-height:24px;vertical-align:middle;margin-left:4px;">
            <mat-icon style="font-size: var(--font-size-md); width:16px;height:16px;line-height:16px;">open_in_new</mat-icon>
          </a>
          <mat-progress-spinner
            *ngIf="loadingMap[i]"
            diameter="14"
            mode="indeterminate"
            class="chart-spinner">
          </mat-progress-spinner>
          <button mat-icon-button (click)="toggleMaximize(i)"
                  [matTooltip]="maximizedIndex === i ? 'Vista mosaico' : 'Maximizar'"
                  style="width:24px;height:24px;line-height:24px;margin-left:auto;">
            <mat-icon style="font-size: var(--font-size-md); width:16px;height:16px;line-height:16px;">
              {{ maximizedIndex === i ? 'close_fullscreen' : 'open_in_full' }}
            </mat-icon>
          </button>
        </div>
        <!-- UI pesada estilo grafica-modelo: solo visible al maximizar esta celda -->
        <div class="chart-topbar" *ngIf="maximizedIndex === i" [class.dark]="isDark">
          <button *ngFor="let tf of timeframeOptions"
            class="btn-topbar"
            [class.active]="c.periodo === tf.periodo || (!c.periodo && tf.periodo === 6)"
            (click)="setChartPeriodo(i, tf.periodo)"
            [disabled]="isChartLocked(i)"
            [title]="isChartLocked(i) ? 'Periodo bloqueado por modelo' : tf.label">
            {{ tf.label }}
          </button>

          <div class="topbar-sep"></div>

          <div class="ind-anchor">
            <button class="btn-topbar" [class.active]="showIndicatorsPanel"
              (click)="toggleIndicatorsPanel(); $event.stopPropagation()">
              <i class="bi bi-activity icon-base"></i>
              <span>Indicadores</span>
              <span class="badge-active" *ngIf="(chartMeta[i]?.indicatorSeries || []).length">
                {{ (chartMeta[i]?.indicatorSeries || []).length }}
              </span>
            </button>

            <div class="ind-panel" *ngIf="showIndicatorsPanel" [class.dark]="isDark" (click)="$event.stopPropagation()">
              <div class="ind-header">
                <div class="ind-search-wrap">
                  <i class="bi bi-search ind-search-icon"></i>
                  <input class="ind-search-input" type="text" [(ngModel)]="indicatorSearch"
                    placeholder="Buscar indicador..." autocomplete="off">
                </div>
                <button class="ind-close-btn" (click)="toggleIndicatorsPanel()">
                  <i class="bi bi-x-lg"></i>
                </button>
              </div>

              <div class="ind-body">
                <div class="ind-section" *ngIf="(chartMeta[i]?.indicatorSeries || []).length">
                  <div class="ind-section-title">
                    <i class="bi bi-check-circle-fill icon-sm" style="color:#26a69a;"></i>
                    En gráfico
                  </div>
                  <div *ngFor="let entry of (chartMeta[i]?.indicatorSeries || [])" class="ind-row">
                    <i class="bi bi-activity ind-row-icon"></i>
                    <span class="ind-row-name" [title]="entry.label">{{ entry.label }}</span>
                    <button *ngIf="entry.source === 'catalog'" class="ind-icon-btn danger"
                      (click)="removeIndicatorFromChart(i, entry.id)" title="Eliminar">
                      <i class="bi bi-trash3"></i>
                    </button>
                  </div>
                </div>

                <div class="ind-divider" *ngIf="(chartMeta[i]?.indicatorSeries || []).length"></div>

                <div class="ind-section">
                  <div class="ind-section-title">
                    <i class="bi bi-bar-chart-line icon-sm"></i>
                    Técnicos disponibles ({{ indicatorCatalog.length }})
                  </div>
                  <div class="ind-empty" *ngIf="indicatorSearch && !filteredIndicatorCatalog.length">
                    Sin resultados para "<strong>{{ indicatorSearch }}</strong>"
                  </div>
                  <div *ngFor="let ind of filteredIndicatorCatalog" class="ind-row"
                    [class.ind-row-added]="isIndicatorInChart(i, ind.id)">
                    <i class="bi ind-row-icon icon-base"
                       [class.bi-check-circle-fill]="isIndicatorInChart(i, ind.id)"
                       [class.bi-graph-up-arrow]="!isIndicatorInChart(i, ind.id)"
                       [class.muted]="!isIndicatorInChart(i, ind.id)"
                       [style.color]="isIndicatorInChart(i, ind.id) ? '#26a69a' : null"></i>
                    <span class="ind-row-name" [title]="ind.title">
                      <span style="font-weight:600;">{{ ind.short }}</span>
                      <span style="color:#888; margin-left:4px;" class="txt-sm">{{ ind.title }}</span>
                    </span>
                    <button *ngIf="!isIndicatorInChart(i, ind.id)" class="ind-icon-btn add"
                      (click)="addIndicatorToChart(i, ind)"
                      [disabled]="isAddingIndicator(i, ind.id)"
                      [title]="isAddingIndicator(i, ind.id) ? 'Calculando...' : 'Añadir al gráfico'">
                      <i class="bi" [class.bi-plus-lg]="!isAddingIndicator(i, ind.id)"
                         [class.bi-hourglass-split]="isAddingIndicator(i, ind.id)"></i>
                    </button>
                    <button *ngIf="isIndicatorInChart(i, ind.id)" class="ind-icon-btn danger"
                      (click)="removeIndicatorFromChart(i, ind.id)" title="Eliminar">
                      <i class="bi bi-trash3"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="topbar-sep"></div>

          <button *ngFor="let r of ranges"
            class="btn-topbar"
            [class.active]="chartMeta[i]?.activeRange === r"
            (click)="setChartRange(i, r)"
            [disabled]="isChartRangeLoading(i)"
            [title]="isChartRangeLoading(i) ? 'Cargando histórico…' : (isChartRangeExhausted(i) ? 'No hay más historial disponible más atrás' : null)">
            {{ r }}
          </button>
        </div>

        <div class="chart-canvas-wrap">
          <div #chartContainer class="chart-container" [style.height.px]="chartHeight"></div>
          <app-chart-legend
            [dateLabel]="chartMeta[i]?.legendDate"
            [crosshairOhlc]="chartMeta[i]?.legendOhlc || null"
            [bid]="chartMeta[i]?.legendBid ?? null"
            [ask]="chartMeta[i]?.legendAsk ?? null"
            [legendItems]="chartMeta[i]?.legendItems || []"
            [condicionEntradaLista]="chartMeta[i]?.condicionEntradaLista || []"
            [condicionSalidaLista]="chartMeta[i]?.condicionSalidaLista || []"
            [showCondiciones]="maximizedIndex === i"
            [isDark]="isDark">
          </app-chart-legend>
          <ng-container *ngIf="maximizedIndex === i">
            <app-drawing-floating-toolbar [controller]="chartMeta[i]?.drawingCtl"></app-drawing-floating-toolbar>
            <app-drawing-object-tree [controller]="chartMeta[i]?.drawingCtl"></app-drawing-object-tree>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
